module.exports = __webpack_public_path__ + "img/Sextans.7db14c45.png";